(function () {
  function initialize(root) {
    if (!root || root.dataset.plLayeringReady === 'true') return;
    root.dataset.plLayeringReady = 'true';

    const filterButtons = Array.from(root.querySelectorAll('[data-layer-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-layer-card]'));
    const count = root.querySelector('[data-pl-layering-count]');
    const noResults = root.querySelector('[data-pl-layering-empty]');

    function filterCards(value) {
      let visible = 0;
      cards.forEach((card) => {
        const audiences = (card.dataset.audiences || '').split('|').map((v) => v.trim().toLowerCase());
        const matches = value === 'all' || audiences.includes(value);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      filterButtons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.layerFilter === value));
      });
      if (count) {
        count.textContent = visible + (visible === 1 ? ' combination' : ' combinations');
      }
      if (noResults) noResults.hidden = visible > 0;
    }

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => filterCards(button.dataset.layerFilter || 'all'));
    });
    filterCards('all');

    const dialog = root.querySelector('[data-pl-duo-dialog]');
    if (!dialog) return;

    const nameA = dialog.querySelector('[data-pl-name-a]');
    const nameB = dialog.querySelector('[data-pl-name-b]');
    const selectA = dialog.querySelector('[data-pl-select-a]');
    const selectB = dialog.querySelector('[data-pl-select-b]');
    const priceA = dialog.querySelector('[data-pl-price-a]');
    const priceB = dialog.querySelector('[data-pl-price-b]');
    const total = dialog.querySelector('[data-pl-duo-total]');
    const addButton = dialog.querySelector('[data-pl-duo-add]');
    const status = dialog.querySelector('[data-pl-duo-status]');
    const closeButton = dialog.querySelector('[data-pl-duo-close]');
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
    const locale = document.documentElement.lang || 'en-AU';
    const format = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
    const rootPath = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
    let selectedDuo = null;
    let pending = false;

    function setStatus(message, isError) {
      status.textContent = message || '';
      status.dataset.error = isError ? 'true' : 'false';
    }

    function variantsFor(product) {
      if (!product || !Array.isArray(product.variants)) return [];
      const sizes = ['2ml', '5ml', '10ml'];
      return product.variants
        .filter((variant) => sizes.includes(variant.title) && Number.isFinite(Number(variant.price)))
        .sort((a, b) => sizes.indexOf(a.title) - sizes.indexOf(b.title));
    }

    function fillSelect(select, product) {
      const variants = variantsFor(product);
      select.replaceChildren();
      variants.forEach((variant) => {
        const option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = variant.title + ' — ' + format.format(Number(variant.price) / 100) + (variant.available ? '' : ' · Sold out');
        option.disabled = variant.available !== true;
        select.appendChild(option);
      });
      const firstAvailable = variants.find((variant) => variant.available === true);
      if (firstAvailable) select.value = String(firstAvailable.id);
      select.disabled = !firstAvailable;
      return Boolean(firstAvailable);
    }

    function chosenVariant(select, product) {
      if (!product) return null;
      return variantsFor(product).find((variant) => variant.available === true && String(variant.id) === select.value) || null;
    }

    function refreshPrices() {
      if (!selectedDuo) return;
      const a = chosenVariant(selectA, selectedDuo.a);
      const b = chosenVariant(selectB, selectedDuo.b);
      priceA.textContent = a ? format.format(Number(a.price) / 100) : 'Unavailable';
      priceB.textContent = b ? format.format(Number(b.price) / 100) : 'Unavailable';
      total.textContent = a && b ? format.format((Number(a.price) + Number(b.price)) / 100) : 'Unavailable';
      addButton.disabled = pending || !a || !b;
      if (!a || !b) {
        setStatus('One or both fragrances are unavailable in the selected sample sizes. Please choose in-stock sizes.', true);
      } else if (!pending) {
        setStatus('', false);
      }
    }

    root.querySelectorAll('[data-pl-duo-open]').forEach((button) => {
      button.addEventListener('click', () => {
        if (pending) return;
        const dataElement = button.closest('.pl-layering__buy')?.querySelector('[data-pl-duo-json]');
        try {
          const parsed = JSON.parse(dataElement?.textContent || 'null');
          if (!parsed || !parsed.a || !parsed.b) throw new Error('Missing sample data');
          selectedDuo = parsed;
          nameA.textContent = parsed.a.title || 'Fragrance A';
          nameB.textContent = parsed.b.title || 'Fragrance B';
          fillSelect(selectA, parsed.a);
          fillSelect(selectB, parsed.b);
          refreshPrices();
          if (!dialog.open) dialog.showModal();
          // Focus the dialog heading, not an iOS native select: focusing a select
          // automatically opens its picker on mobile Safari.
          const dialogHeading = dialog.querySelector('[data-pl-duo-heading]');
          if (dialogHeading) dialogHeading.focus({ preventScroll: true });
          else closeButton.focus({ preventScroll: true });
        } catch (error) {
          console.warn('Layering duo data could not be loaded.', error);
          button.textContent = 'Samples unavailable — please refresh';
          button.disabled = true;
        }
      });
    });

    selectA.addEventListener('change', refreshPrices);
    selectB.addEventListener('change', refreshPrices);

    closeButton.addEventListener('click', () => {
      if (!pending) dialog.close();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog && !pending) dialog.close();
    });

    dialog.addEventListener('cancel', (event) => {
      if (pending) event.preventDefault();
    });

    addButton.addEventListener('click', async () => {
      if (pending || !selectedDuo) return;
      const a = chosenVariant(selectA, selectedDuo.a);
      const b = chosenVariant(selectB, selectedDuo.b);
      if (!a || !b) {
        refreshPrices();
        return;
      }
      pending = true;
      addButton.disabled = true;
      closeButton.disabled = true;
      addButton.textContent = 'Adding both samples…';
      setStatus('Adding your two selected sample sizes to the cart…', false);

      try {
        const response = await fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: Number(a.id), quantity: 1 },
              { id: Number(b.id), quantity: 1 }
            ]
          })
        });
        const result = await response.json().catch(() => null);
        if (!response.ok) {
          const message = result && (result.description || result.message);
          throw new Error(typeof message === 'string' ? message : 'Shopify could not add both sizes. Please check the selected sizes and try again.');
        }
        setStatus('Both samples added. Opening your cart…', false);
        window.location.assign(rootPath + 'cart');
      } catch (error) {
        pending = false;
        closeButton.disabled = false;
        addButton.textContent = 'Add Both Samples to Cart';
        refreshPrices();
        setStatus(error && error.message ? error.message : 'Unable to add both samples. Please check your cart before trying again.', true);
      }
    });
  }

  function setup() {
    document.querySelectorAll('[data-pl-layering]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();